// ======================================================================
// File Name       : enterprise
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import { camelizeKeys, decamelize, decamelizeKeys } from 'humps';
import { callHupApi, commonCallApi } from '../../utils/ApiUtils';
import { STRUCTURE_LEVEL, SELECT_TARGET_DATA, LO_SUPER_USER, SUPER_USER } from '../../constants';

export function postEnterpriseGetStructure(
  data = {
    targetEnterpriseCd: null,
    selectTargetData: SELECT_TARGET_DATA.DATA,
    recursiveType: STRUCTURE_LEVEL.ALL,
  },
) {
  return commonCallApi({
    path: 'enterprise/GetStructure',
    data,
    enterpriseId: 1,
  });
}

export function postEnterpriseEdit(
  data = {
    editType: null,
    enterpriseInfo: null,
  },
) {
  return commonCallApi({
    path: 'enterprise/Edit',
    data,
    enterpriseId: 1,
  });
}

export function postEnterpriseNoticeEdit(
  data = {
    editType: null,
    noticeInfo: null,
  },
) {
  return commonCallApi({
    path: 'noticeForEnterprise/Edit',
    data,
    enterpriseId: 1,
  });
}

export function postEnterpriseNoticeDetail(
  data = {
    selectTargetData: 0,
    searchInfo: null,
  },
) {
  return commonCallApi({
    path: 'noticeForEnterprise/GetList',
    data,
    enterpriseId: 1,
  });
}

// sprint_20230403 #14 START
export function postSignUpPreCancel(data) {
  return commonCallApi({
    path: 'signup/precancel',
    data: { ...data },
    externalServer: true,
  });
}
// sprint_20230403 #14 END

// sprint_20230418 #15 START
export function postCheckAvailability(displayUserType) {
  const superUser = [LO_SUPER_USER, SUPER_USER].indexOf(displayUserType) > -1;
  if (superUser) {
    return commonCallApi({
      path: 'enterprise/CheckAvailability',
      enterpriseId: 1,
    });
  }

  return commonCallApi({
    path: 'enterprise/CheckAvailability',
  });
}
// sprint_20230418 #15 END
// sprint_20230522_tma START
export function reasonForCancelEnterprise(data) {
  return callHupApi({
    path: 'events/v3/send',
    data: { ...data },
  });
}
// sprint_20230522_tma END
